import { useCallback, useEffect, useMemo, useState } from 'react';
import { DragEndEvent } from '@dnd-kit/core';
import { DealRoomTopNodes } from 'models/DealRoom';
import { arrayMove } from '@dnd-kit/sortable';
import { getHasElementsInArray } from 'utils';
import { getTopFilesForLeads } from '../../../utils';

export default function useReordering(
  dealRoomTopNodes: DealRoomTopNodes[],
  dealRoomStarredNodes: DealRoomTopNodes[],
) {
  const hasStarredNodes = useMemo(
    () => getHasElementsInArray(dealRoomStarredNodes),
    [dealRoomStarredNodes],
  );

  const nodes = useMemo(
    () =>
      getTopFilesForLeads(dealRoomTopNodes, dealRoomStarredNodes).map(
        ({ dataRoomNode }) => dataRoomNode,
      ),
    [dealRoomStarredNodes, dealRoomTopNodes],
  );

  const [items, setItems] = useState(nodes);

  const resetItems = useCallback(() => setItems(nodes), [nodes]);

  const onDragEnd = useCallback((e: DragEndEvent) => {
    const { active, over } = e;

    if (!over || active.id === over.id) return;

    setItems((items) => {
      const oldIndex = items.findIndex(({ _id }) => _id === active.id);
      const newIndex = items.findIndex(({ _id }) => _id === over.id);

      return arrayMove(items, oldIndex, newIndex);
    });
  }, []);

  useEffect(() => {
    setItems(nodes);
  }, [nodes]);

  return {
    hasStarredNodes,
    items,
    onDragEnd,
    resetItems,
  };
}
